"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProd = void 0;
const isProd = () => process.env.NODE_ENV === 'production';
exports.isProd = isProd;
